import React, { useState, useEffect, createContext } from 'react'
import isEqual from 'lodash/isEqual'
import { ViewCart } from '../../../../lib/gtm/index'

interface Props {
  children: JSX.Element
}

interface CartContextInterface {
  cartItemData: any
  setCartItemData: (param: any) => void
  savedCartItem: any
  setSavedCartItem: (param: any) => void
  shouldWarning: boolean
}

export const CartContext = createContext<CartContextInterface>({
  cartItemData: {},
  setCartItemData: () => undefined,
  savedCartItem: {},
  setSavedCartItem: () => undefined,
  shouldWarning: false
})

export const CartProvider = ({ children }: Props) => {
  const [cartItemData, setCartItemData] = useState()
  const [savedCartItem, setSavedCartItem] = useState()
  const cartItemDataIsEqual = isEqual(cartItemData, savedCartItem)
  const [shouldWarning, setShouldWarning] = useState(false)

  useEffect(() => {
    if (!cartItemDataIsEqual) {
      setShouldWarning(true)
    } else {
      setShouldWarning(false)
    }
    // eslint-disable-next-line
  }, [cartItemData])

  return (
    <CartContext.Provider
      value={{
        cartItemData,
        setCartItemData,
        savedCartItem,
        setSavedCartItem,
        shouldWarning
      }}
    >
      <ViewCart />

      {children}
    </CartContext.Provider>
  )
}

export const useCartContextProvider = () => {
  const context = React.useContext(CartContext)
  if (context === undefined) {
    throw new Error('useCart must be used within a CartProvider')
  }
  return context
}
